import { render, staticRenderFns } from "./RecruiterQaTicketList.vue?vue&type=template&id=436958e1&scoped=true"
import script from "./RecruiterQaTicketList.vue?vue&type=script&lang=js"
export * from "./RecruiterQaTicketList.vue?vue&type=script&lang=js"
import style0 from "./RecruiterQaTicketList.vue?vue&type=style&index=0&id=436958e1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "436958e1",
  null
  
)

export default component.exports